module.exports = __webpack_public_path__ + "img/xuanxing_banner.1618d119.jpg";